import S from "../index.module.scss";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";

const ProductCardLoading = () => {
  return (
    <Link className={S.card} href={"#"}>
      <div className={S.productImageSkeleton} />
      <div className={S.cardInfo}>
        <Skeleton className={S.nameSkeleton} height={20} />
        <Skeleton className={S.collectionSkeleton} height={20} />
      </div>
    </Link>
  );
};

export default ProductCardLoading;
